import { Controller } from '@hotwired/stimulus';

/**
 * This controller detects swipe gestures on the element it is connected to.
 *
 * At the moment, it detects only upward swipes and dispatches a swipe swipe:up if one is detected.
 *
 * Connects to data-controller="swipe"
 */
export default class extends Controller {
  connect() {
    this.touchmoveHandler = this.handleTouchmove.bind(this);
    this.element.addEventListener('touchmove', this.touchmoveHandler);
  }

  disconnect() {
    document.removeEventListener('touchmove', this.touchmoveHandler);
  }

  handleTouchmove(event) {
    if (
      event &&
      event.touches &&
      event.touches[0] &&
      event.touches[0].clientY
    ) {
      if (!this.touchstartClientY) {
        this.touchstartClientY = event.touches[0].clientY;
      } else {
        if (this.touchstartClientY - event.touches[0].clientY > 10) {
          this.dispatch('up');
        }
      }
    }

    // Stop the gesture from shifting the page content as a whole, which creates a somewhat instable
    // effect.
    event.preventDefault();
  }
}
